import React from "react";
import { Token } from "../../types/tournament";
import { useTheme } from "../../contexts/ThemeContext";

interface TokenInfoProps {
  token: Token;
  side: "left" | "right";
  isDead: boolean;
}

const TokenInfo: React.FC<TokenInfoProps> = ({
  token,
  side,
  isDead,
}) => {
  const { colors } = useTheme();
  
  const getSymbolColor = () => {
    if (isDead) return "text-gray-500";
    return side === "left" ? colors.teamA.text : colors.teamB.text;
  };

  const getNameColor = () => {
    if (isDead) return "text-gray-600";
    return side === "left" ? colors.teamA.textLight.replace('/70', '/50') : colors.teamB.textLight.replace('/70', '/50');
  };

  const alignmentClass = side === "left" ? "text-left" : "text-right";
  const marginClass = side === "left" 
    ? "ml-24 sm:ml-28 md:ml-32 lg:ml-36"
    : "mr-24 sm:mr-28 md:mr-32 lg:mr-36";

  return (
    <div className={`${alignmentClass} ${marginClass}`}>
      <div className={`font-black text-lg sm:text-xl md:text-2xl uppercase tracking-wider ${getSymbolColor()}`}>
        {token.symbol}
      </div>
      <div className={`text-xs sm:text-sm ${getNameColor()}`}>
        {token.name}
      </div>
    </div>
  );
};

export default TokenInfo;